import isNil from 'lodash/isNil';
import { addMilliseconds, format } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';
import { InventoryViewMode } from '../components/Widget/InventoryWidget/inventory.types';
import { Amount, Convert } from '@topconagriculture/unit-of-measure';
import { getUnitFormatLabel } from '@topconagriculture/unit-of-measure/dist/format';
const dateFormatOptions = {
    year: '2-digit',
    day: '2-digit',
    month: '2-digit',
};
const formatPartMapper = (x) => {
    if (x.type === 'year') {
        return 'yyyy';
    }
    else if (x.type === 'month') {
        return 'MM';
    }
    else if (x.type === 'day') {
        return 'dd';
    }
    else if (x.type === 'hour') {
        return 'HH';
    }
    else if (x.type === 'minute') {
        return 'mm';
    }
    else if (x.type === 'second') {
        return 'ss';
    }
    else if (x.type === 'dayPeriod') {
        return 'a';
    }
    else {
        return x.value;
    }
};
export const getWarningsNumber = (inventory) => {
    if (inventory) {
        const criticalCount = inventory.filter(({ critical }) => critical).length;
        const earlyCount = inventory.length - criticalCount;
        return { criticalCount, earlyCount };
    }
    return { criticalCount: '', earlyCount: '' };
};
const naturalSorting = (a, b) => {
    if (!(a === null || a === void 0 ? void 0 : a.length) && !(b === null || b === void 0 ? void 0 : b.length)) {
        return 0;
    }
    if (!(a === null || a === void 0 ? void 0 : a.length)) {
        return 1;
    }
    if (!(b === null || b === void 0 ? void 0 : b.length)) {
        return -1;
    }
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
};
export const filterInventory = (inventory, viewMode) => {
    if (!inventory) {
        return [];
    }
    return inventory
        .filter((ingredient) => (viewMode === InventoryViewMode.CRITICAL ? ingredient.critical : !ingredient.critical))
        .sort((a, b) => naturalSorting(a.description, b.description));
};
export const getInventoryParams = (inventory) => {
    const viewMoreButtonIsDisabled = !(inventory === null || inventory === void 0 ? void 0 : inventory.length);
    const includedIngredients = inventory === null || inventory === void 0 ? void 0 : inventory.map(({ id }) => id).join(',');
    return { viewMoreButtonIsDisabled, includedIngredients };
};
export function getSeparator(separatorType) {
    const numberWithGroupAndDecimalSeparator = 1000.1;
    const separator = Intl.NumberFormat(navigator.language)
        .formatToParts(numberWithGroupAndDecimalSeparator)
        .find((part) => part.type === separatorType);
    return separator ? separator.value : ' ';
}
export const getDecimalSeparator = () => {
    return getSeparator('decimal');
};
export const getThousandSeparator = () => {
    return getSeparator('group');
};
export const isNumeric = (val) => isNil(val) ? false : /-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?/.test(val.toString());
export const formatNumberByRegion = (num, decimal) => {
    if (!isNumeric(num)) {
        return num;
    }
    const decimalSeparator = getDecimalSeparator();
    const thousandSeparator = getThousandSeparator();
    const [intPart, decimalPart] = String(decimal ? num.toFixed(decimal) : num).split('.');
    return `${intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`)}${decimalPart ? `${decimalSeparator}${decimalPart}` : ''}`;
};
export const getDateFormat = () => {
    const formatter = Intl.DateTimeFormat(navigator.language, dateFormatOptions);
    const parts = formatter.formatToParts(new Date());
    return parts.map((x) => formatPartMapper(x)).join('');
};
const timeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
};
const fullTimeFormatOptions = {
    ...timeFormatOptions,
    second: '2-digit',
};
export const getDateTimeFormat = (withSeconds) => {
    const formatter = Intl.DateTimeFormat(navigator.language, {
        ...dateFormatOptions,
        ...(withSeconds ? fullTimeFormatOptions : timeFormatOptions),
    });
    const parts = formatter.formatToParts(new Date());
    const partsMapped = parts.map((x) => formatPartMapper(x));
    const pattern = partsMapped.join('');
    return partsMapped.includes('a') ? pattern.replace('HH', 'hh') : pattern;
};
export const toFarmTimeZone = (date, timezone) => {
    const offset = getTimezoneOffset(timezone, date);
    return addMilliseconds(date, offset);
};
export const formatDate = (date, dateFormat) => {
    return date && dateFormat ? format(date, dateFormat) : '';
};
export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export const convertUnitByMeasureSystem = (unit, value, system) => {
    const amount = Amount.create(value, unit);
    const converted = Convert.convertAmountByUnitOfMeasureQuantity(system, amount);
    const label = getUnitFormatLabel(converted.unit);
    return { unit: converted.unit, unitLabel: label, value: converted.value };
};
export const getGeolocation = () => {
    if (navigator.geolocation) {
        return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject));
    }
    else {
        return new Promise((resolve) => resolve(undefined));
    }
};
//# sourceMappingURL=utils.js.map